import React from 'react'
import app from '../../../feathers'
import styled from 'styled-components'
import { IconButton } from 'react-mdl'
import Button from '../../../components/Button'
import ScrollingDialog from '../../../components/ScrollingDialog'
import Image from 'react-image-resizer'
import BlockingSpinner from '../../components/BlockingSpinner'

const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const ImageActionsContainer = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
`

class ImageDialog extends React.Component {
  state = this.getInitialState(this.props)
  getInitialState({ _id, images }) {
    return { _id, images, saving: false, imageIds: [] }
  }
  deleteImage = i =>
    this.setState(({ images }) => ({
      images: [...images.slice(0, i), ...images.slice(i + 1)],
    }))
  handleChangeDescription = ({ target: { name: i, value } }) =>
    this.setState(({ images }) => ({
      images: [
        ...images.slice(0, i),
        { ...images[i], description: value },
        ...images.slice(i + 1),
      ],
    }))
  handleChangeTags = ({ target: { name: i, value } }) =>
    this.setState(({ images }) => ({
      images: [
        ...images.slice(0, i),
        { ...images[i], tags: value.split(', ') },
        ...images.slice(i + 1),
      ],
    }))
  discardChanges = () => this.setState(this.getInitialState(this.props))
  saveImages = async () => {
    const { _id, images } = this.state
    this.setState({ saving: true })
    const responses = await Promise.all(
      images.map(async ({ image, description, tags }) => {
        const body = new FormData()
        body.append('image', image)
        body.append('tags', tags)
        body.append('description', description)
        const token = await app.passport.getJWT()
        const response = await fetch('/images/', {
          method: 'POST',
          body,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        if (!response.ok) {
          return alert(`Failed to upload image. ${await response.text()}`)
        }
        return response.json()
      }),
    )
    const mediaIds = responses.map(({ imageId }) => imageId)
    await app.service('units').patch(_id, {
      $pushAll: {
        images: mediaIds,
      },
    })
    this.setState({ saving: false })
    this.props.onSave()
    this.props.goBack()
  }

  render() {
    const hasImages = this.state.images.length > 0
    const { saving } = this.state
    return (
      <ScrollingDialog
        title="Unit Images"
        actions={
          <Row>
            <Button raised accent onClick={this.discardChanges}>
              Discard Changes
            </Button>
            {hasImages
              ? <Button raised primary onClick={this.saveImages}>
                  Save Images
                </Button>
              : <div />}
          </Row>
        }>
        <div>
          {hasImages
            ? this.state.images.map(({ image, description, tags }, i) =>
                <div key={i}>
                  <Row>
                    <ImageActionsContainer>
                      <Image
                        src={URL.createObjectURL(image)}
                        height={400}
                        width={400}
                        style={{ margin: '10px' }}
                        alt="from docx"
                      />
                    </ImageActionsContainer>
                    <ImageActionsContainer>
                      <Button
                        raised
                        primary
                        onClick={() => this.deleteImage(i)}>
                        Delete Image
                      </Button>
                      <h5>Description</h5>
                      <textarea
                        name={i}
                        value={description}
                        rows={5}
                        onChange={this.handleChangeDescription}
                      />
                      <h5>Tags</h5>
                      <p>Note: Separate each tag with a comma and a space.</p>
                      <textarea
                        name={i}
                        value={tags.join(', ')}
                        rows={5}
                        onChange={this.handleChangeTags}
                      />
                    </ImageActionsContainer>
                  </Row>
                  <hr width="100%" size={3} />
                </div>,
              )
            : <h1>No Images to display</h1>}
          <IconButton
            style={{ position: 'absolute', top: 0, right: 0 }}
            name="close"
            onClick={this.props.goBack}
          />
          {saving && <BlockingSpinner>Saving...</BlockingSpinner>}
        </div>
      </ScrollingDialog>
    )
  }
}

export default ImageDialog



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/UnitSettings/ImageDialog.js